/******/ (() => { // webpackBootstrap
/* eslint-disable */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.isProcessing = false;
    this.cacheDOMElements();
    this.onSubmitBound = this.onSubmit.bind(this);
    this.handleQuickViewModal = this.handleQuickViewModal.bind(this);
  }

  cacheDOMElements() {
    this.form = this.querySelector('form');
    this.sectionId = this.getAttribute('data-section-id');
    this.productInformation = this.closest('product-information');
    this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
    this.cartType = document.getElementById('PageContainer').dataset.cartType;
    this.cartCountIndicator = document.querySelector('[data-cart-count-indicator]');
    this.giftWrapProductId = this.getAttribute('data-gift-wrap-product-id');
    this.productHandle = this.getAttribute('data-product-handle') || '';
    this.mealPlanProduct = this.getAttribute('data-meal-plan-product') === 'true';
    this.depositProductHandle = this.getAttribute('data-deposit-product-handle') || '';
    this.fertilitySurchargeProductHandle = this.getAttribute('data-fertility-surcharge-product-handle') || 'fertility-surcharge-100-aed';
    this.mealPlanDiscountCodesRaw = this.getAttribute('data-meal-plan-discount-codes') || '{}';
    this.mealPlanDiscountCodes = this.parseMealPlanDiscountCodes(this.mealPlanDiscountCodesRaw);
    // Expose globally so the cart-cleanup logic can recalculate the
    // appropriate discount code when items are removed (it has no other
    // way to access the per-product mapping).
    if (this.mealPlanProduct && Object.keys(this.mealPlanDiscountCodes).length > 0) {
      window.__rawkureMealPlanDiscountCodes = this.mealPlanDiscountCodes;
    }
    this.mealPlanDepositVariantId = null;
    this.fertilitySurchargeVariantId = null;
    this.wethemeGlobal = document.querySelector('script#wetheme-global');
    this.translationsObject = JSON.parse(this.wethemeGlobal.textContent);
    this.qtyErrorMessage = this.querySelector('[data-qty-error-message]');
  }

  connectedCallback() {
    if (!this.form) return;
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.form.addEventListener('submit', this.onSubmitBound);
  }

  onSubmit(event) {
    event.preventDefault();

    // Prevent duplicate submissions
    if (this.isProcessing) {
      return;
    }

    this.prepareForSubmission();
  }

  prepareForSubmission() {
    this.cacheSubmissionElements();
    if (!this.checkRequiredInputs()) return;
    this.disableBlankInputs();
    // If the form is valid, proceed with the submission
    this.showLoadingState();
    this.addItemsToCart();
  }

  cacheSubmissionElements() {
    this.loadingIcon = this.form.querySelector('[data-loading-icon]');
    this.addToCartText = this.form.querySelector('[data-add-to-cart-text]');
    this.addedText = this.form.querySelector('[data-cart-added-text]');
    this.syncMealPlanQuantityFromWeeks();
    this.quantityInput = this.form.querySelector('[name="quantity"]');
    this.quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;
  }

  syncMealPlanQuantityFromWeeks() {
    if (!this.mealPlanProduct || !this.form) return;
    const formId = this.form.getAttribute('id');
    const selectedWeeksInput = document.querySelector(`input[name="properties[Weeks]"][form="${formId}"]:checked`) || document.querySelector('input[name="properties[Weeks]"]:checked');
    if (!selectedWeeksInput) return;

    let weeks = parseInt(selectedWeeksInput.dataset.weeks || '', 10);
    if (!Number.isFinite(weeks) || weeks < 1) {
      const valueMatch = String(selectedWeeksInput.value || '').match(/\d+/);
      weeks = valueMatch ? parseInt(valueMatch[0], 10) : 1;
    }

    weeks = Math.max(1, weeks);
    this.form.querySelectorAll('[name="quantity"]').forEach((quantityField) => {
      quantityField.value = String(weeks);
    });
  }

  parseMealPlanDiscountCodes(rawValue) {
    if (!rawValue) return {};
    try {
      const parser = document.createElement('textarea');
      parser.innerHTML = rawValue;
      const decoded = parser.value || rawValue;
      const parsed = JSON.parse(decoded);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      console.warn('Invalid meal plan discount codes JSON. Expected object map.', error);
      return {};
    }
  }

  getSelectedWeeksInput() {
    if (!this.form) return null;
    const formId = this.form.getAttribute('id');
    return document.querySelector(`input[name="properties[Weeks]"][form="${formId}"]:checked`) || document.querySelector('input[name="properties[Weeks]"]:checked');
  }

  getSelectedWeekData() {
    const selectedWeeksInput = this.getSelectedWeeksInput();
    if (!selectedWeeksInput) return { weeks: 1, discountRate: 0 };

    let weeks = parseInt(selectedWeeksInput.dataset.weeks || '', 10);
    if (!Number.isFinite(weeks) || weeks < 1) {
      const valueMatch = String(selectedWeeksInput.value || '').match(/\d+/);
      weeks = valueMatch ? parseInt(valueMatch[0], 10) : 1;
    }

    let discountRate = parseFloat(selectedWeeksInput.dataset.discount || '');
    if (!Number.isFinite(discountRate) || discountRate <= 0) {
      const discountMatch = String(selectedWeeksInput.value || '').match(/(\d+(?:\.\d+)?)\s*%/);
      discountRate = discountMatch ? parseFloat(discountMatch[1]) : 0;
    }
    if (discountRate > 1) discountRate = discountRate / 100;

    return {
      weeks: Math.max(1, weeks),
      discountRate: Math.max(0, discountRate)
    };
  }

  resolveMealPlanDiscountCode(weekData) {
    const map = this.mealPlanDiscountCodes || {};
    const weeksKey = String(weekData.weeks || '');
    const percent = Math.round((weekData.discountRate || 0) * 100);
    const percentKey = String(percent);

    if (map.weeks && typeof map.weeks === 'object' && typeof map.weeks[weeksKey] === 'string' && map.weeks[weeksKey].trim()) {
      return map.weeks[weeksKey].trim();
    }
    if (typeof map[weeksKey] === 'string' && map[weeksKey].trim()) {
      return map[weeksKey].trim();
    }
    if (map.percentages && typeof map.percentages === 'object' && typeof map.percentages[percentKey] === 'string' && map.percentages[percentKey].trim()) {
      return map.percentages[percentKey].trim();
    }
    if (typeof map[percentKey] === 'string' && map[percentKey].trim()) {
      return map[percentKey].trim();
    }
    return '';
  }

  async applyCartDiscountCode(discountCode) {
    // To CLEAR: hitting /discount with an empty code + redirect is more
    // reliable across Shopify versions than '/cart?discount='.
    const endpoint = discountCode
      ? `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent('/cart')}`
      : `/discount/?redirect=${encodeURIComponent('/cart')}`;

    try {
      await fetch(endpoint, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
    } catch (error) {
      console.warn('Failed applying cart discount code', error);
    }
  }

  disableBlankInputs() {
    // Select all input and textarea elements
    const elements = this.productInformation.querySelectorAll('input, textarea');
    this.blankElements = [];

    elements.forEach((element) => {
      // Check if the element has no value
      if (!element.value) {
        // Temporarily disable the element so that it is not included in the form submission
        element.disabled = true;
        this.blankElements.push(element);
      }
    });
  }

  enableBlankInputs() {
    // Enable the blank elements that were disabled
    this.blankElements.forEach((element) => {
      element.disabled = false;
    });
    this.blankElements = [];
  }

  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  checkRequiredInputs() {
    const requiredInputs = Array.from(this.productInformation.querySelectorAll('[required]:not(:disabled):not([data-input-ignore])'));
    this.clearErrorMessages();

    const invalidInputs = requiredInputs.filter(input => {
      if (input.type === 'checkbox') {
        return !input.checked;
      } else {
        return !input.value.trim();
      }
    });

    invalidInputs.forEach(input => this.applyErrorMessage(input));
    return invalidInputs.length === 0;
  }

  clearErrorMessages() {
    this.productInformation.querySelectorAll('.required-field-error').forEach(error => error.remove());
  }

  applyErrorMessage(input) {
    if (!input) return;
    const inputId = input.id;
    const buttonWrapper = this.querySelector('.paymentButtonsWrapper');
    const errorContainer = input.closest('.input-wrapper')?.querySelector('.input-error-container');
    const errorMessage = input.hasAttribute('custom-dropdown-input') ? this.translationsObject.translations.required_dropdown_error : input.type === 'file' ? this.translationsObject.translations.required_upload_error : input.type === 'checkbox' ? this.translationsObject.translations.required_checkbox_error : this.translationsObject.translations.required_input_error;
    const errorElement = `<span id="${inputId}" class="required-field-error errors" style="display: block;">${errorMessage}</span>`;
    const submitErrorMessage = input.type == 'file' ? input.closest('file-upload')?.dataset.errorMessage : input.dataset.errorMessage;
    const submitErrorElement = `<span id="${inputId}Submit" class="required-field-error errors" style="display: block;" role="alert">${submitErrorMessage}</span>`;
    errorContainer ? errorContainer.innerHTML = errorElement : input.insertAdjacentHTML('beforebegin', errorElement);
    if (buttonWrapper) buttonWrapper.insertAdjacentHTML('beforebegin', submitErrorElement);
    input.focus();

    // If the input has an error message, add an 'input' event listener to remove the error message
    if (input.type == 'file') return;
    input.addEventListener('input', () => {
      this.productInformation.querySelector(`#${inputId}.required-field-error`)?.remove();
      this.querySelector(`#${inputId}Submit.required-field-error`)?.remove();
    }, { once: true });
  }

  giftWrapEnabled() {
    const giftWrapProp = this.closest('product-information')?.getAttribute('data-gift-wrap-prop');
    if (!giftWrapProp || !this.giftWrapProductId) return false;
    const name = `properties[${giftWrapProp}]`;
    const selector = `[name="${CSS.escape(name)}"]`;
    return !!this.productInformation.querySelector(selector)?.checked;
  }

  async resolveMealPlanDepositVariantId() {
    if (!this.mealPlanProduct) return null;
    if (this.mealPlanDepositVariantId) return this.mealPlanDepositVariantId;

    const candidateHandles = [this.depositProductHandle, 'bag-deposit-refundable', 'bag-deposit'].filter(Boolean);

    for (const handle of candidateHandles) {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
          method: 'GET',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) continue;
        const product = await response.json();
        const variantId = product?.selected_or_first_available_variant?.id || product?.variants?.[0]?.id;
        if (!variantId) continue;
        this.mealPlanDepositVariantId = parseInt(variantId, 10);
        return this.mealPlanDepositVariantId;
      } catch (error) {
        console.warn(`Unable to resolve deposit variant via handle "${handle}"`, error);
      }
    }

    return null;
  }

  mealPlanDepositProperties() {
    return {
      '_rawkure_locked_deposit': 'true',
      '_rawkure_is_deposit': 'true',
      // Use generic tag (NOT the product handle) so the cart drawer's
      // auto-delete-by-parent-handle logic can't match and remove this deposit
      // when a single meal plan is removed while others remain in the cart.
      '_rawkure_meal_plan_parent': 'global_cart_deposit'
    };
  }

  fertilitySurchargeEnabled() {
    return this.productHandle === 'fertility-and-maternal-nutrition';
  }

  async resolveFertilitySurchargeVariantId() {
    if (!this.fertilitySurchargeEnabled()) return null;
    if (this.fertilitySurchargeVariantId) return this.fertilitySurchargeVariantId;

    const candidateHandles = [this.fertilitySurchargeProductHandle, 'fertility-surcharge-100-aed'].filter(Boolean);

    for (const handle of candidateHandles) {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
          method: 'GET',
          cache: 'no-store',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) continue;
        const product = await response.json();
        const variantId = product?.selected_or_first_available_variant?.id || product?.variants?.[0]?.id;
        if (!variantId) continue;
        this.fertilitySurchargeVariantId = parseInt(variantId, 10);
        return this.fertilitySurchargeVariantId;
      } catch (error) {
        console.warn(`Unable to resolve fertility surcharge variant via handle "${handle}"`, error);
      }
    }

    return null;
  }

  fertilitySurchargeProperties() {
    return {
      '_rawkure_locked_deposit': 'true',
      '_rawkure_is_fertility_surcharge': 'true',
      '_rawkure_meal_plan_parent': this.productHandle || 'fertility-and-maternal-nutrition'
    };
  }

  async getCartJson() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      console.warn('Unable to fetch cart.json for surcharge verification', error);
      return null;
    }
  }

  hasFertilitySurchargeLine(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    const parentHandle = this.productHandle || 'fertility-and-maternal-nutrition';
    return cart.items.some((item) => {
      const props = item && item.properties ? item.properties : {};
      return props['_rawkure_is_fertility_surcharge'] === 'true' && props['_rawkure_meal_plan_parent'] === parentHandle;
    });
  }

  async addFertilitySurchargeWithFallback(variantId) {
    const properties = this.fertilitySurchargeProperties();

    // Primary add path (same as other add-ons in this theme)
    await this.addProductToCart(
      routes.cart_add_url,
      this.additionalProductConfig(variantId, 1, properties)
    );

    let cart = await this.getCartJson();
    if (this.hasFertilitySurchargeLine(cart)) return true;

    // Fallback add path for themes/stores where JSON items+sections payload is ignored
    const fallbackFormData = new FormData();
    fallbackFormData.append('id', String(variantId));
    fallbackFormData.append('quantity', '1');
    Object.entries(properties).forEach(([key, value]) => {
      fallbackFormData.append(`properties[${key}]`, String(value));
    });
    if (this.cartType === 'drawer') {
      fallbackFormData.append('sections', 'cart-drawer');
    }

    await fetch(routes.cart_add_url, {
      method: 'POST',
      body: fallbackFormData,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    cart = await this.getCartJson();
    return this.hasFertilitySurchargeLine(cart);
  }

  async addItemsToCart() {
    this.isProcessing = true;
    try {
      if (this.mealPlanProduct) {
        const weekData = this.getSelectedWeekData();
        const discountCode = this.resolveMealPlanDiscountCode(weekData);
        await this.applyCartDiscountCode(discountCode);
      }

      // Add the main product to the cart
      const mainProductAdded = await this.addProductToCart(routes.cart_add_url, this.fetchConfigWithBody());
      if (mainProductAdded?.ok && this.giftWrapEnabled()) {
        // Add the gift wrap product to the cart
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(this.giftWrapProductId, this.quantity));
      }

      if (mainProductAdded?.ok && this.mealPlanProduct) {
        // Check current cart state to prevent double deposits (ARRAY-SAFE: Shopify
        // returns line.properties as either an object {} or an array of {name,value}
        // depending on context — must handle both shapes).
        const cart = await this.getCartJson();
        const hasDeposit = cart && cart.items && cart.items.some(item => {
          if (!item.properties) return false;
          if (Array.isArray(item.properties)) {
            return item.properties.some(p => p.name === '_rawkure_is_deposit' && String(p.value) === 'true');
          }
          return String(item.properties['_rawkure_is_deposit']) === 'true';
        });

        if (!hasDeposit) {
          const depositVariantId = await this.resolveMealPlanDepositVariantId();
          if (depositVariantId) {
            await this.addProductToCart(
              routes.cart_add_url,
              this.additionalProductConfig(depositVariantId, 1, this.mealPlanDepositProperties())
            );
          } else {
            console.warn('Meal plan deposit variant was not resolved. Deposit item was not added.');
          }
        }
      }

      if (mainProductAdded?.ok && this.fertilitySurchargeEnabled()) {
        const fertilitySurchargeVariantId = await this.resolveFertilitySurchargeVariantId();
        if (fertilitySurchargeVariantId) {
          const surchargeAdded = await this.addFertilitySurchargeWithFallback(fertilitySurchargeVariantId);
          if (!surchargeAdded) {
            console.error('Fertility surcharge add verification failed after fallback attempt.');
          }
        } else {
          console.warn('Fertility surcharge variant was not resolved. Surcharge item was not added.');
        }
      }

      // Process the response
      this.processResponse(mainProductAdded);
    } catch (error) {
      console.error(`Error adding item(s) to cart: ${error.description || error.message}`);
    } finally {
      this.isProcessing = false;
    }
  }

  async addProductToCart(url, config) {
    const response = await fetch(url, config);
    if (response.ok) {
      // Update cart drawer
      if (this.cartType === 'drawer') {
        const responseJson = await response.json();
        this.updateCartDrawer(responseJson);
      }
    } else {
      console.error(`Error adding item to cart: ${response.description || response.statusText}`);
    }
    return response;
  }

  additionalProductConfig(productId, quantity, properties = {}) {
    const item = { id: productId, quantity: quantity };
    if (Object.keys(properties).length) {
      item.properties = properties;
    }
    const additionalItemPayload = { items: [item] };
    if (this.cartType === 'drawer') {
      additionalItemPayload['sections'] = 'cart-drawer';
    }
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(additionalItemPayload)
    };
  }

  updateCartDrawer(responseJson) {
    eventBus.emit('update:cart:drawer', responseJson);
  }

  async getCart() {
    try {
      const response = await fetch(`${routes.cart_url}?view=compare`);
      return await response.json();
    } catch (error) {
      console.error(`Error fetching cart: ${error.description || error.message}`);
    }
  }

  updateCartCountIndicator() {
    if (!this.cartCountIndicator) return;
    this.getCart().then(cart => window.wetheme.updateCartCount(cart));
  }

  fetchConfigWithBody() {
    const config = this.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = this.addSectionsParam(new FormData(this.form));
    return config;
  }

  addSectionsParam(formData) {
    if (this.cartType === 'drawer') {
      formData.append('sections', 'cart-drawer');
    }
    return formData;
  }

  processResponse(response) {
    if (response.ok) {
      this.hideLoadingState();
    }

    // Handle the case where the product is out of stock
    if (response.status === 422) {
      window.eventBus.emit('render:cart:drawer');
      this.hideLoadingState();
      if (this.qtyErrorMessage) this.qtyErrorMessage.classList.remove('hidden');
    }

    // Emit the cart:added event
    eventBus.emit('cart:added', { sectionId: this.sectionId });

    // Handle quick view modal if we're in one
    this.handleQuickViewModal();

    // Re-enable the blank inputs
    this.enableBlankInputs();
  }

  openCartDrawer() {
    eventBus.emit('open:cart:drawer', { scrollToTop: true });
  }

  handleQuickViewModal() {
    if (this.closest('[data-quick-view-product]')) {
      const closeModal = () => {
        const isModalOpen = document.body.classList.contains('theme-modal-open');
        if (isModalOpen) {
          eventBus.emit('theme:modal:hide');
        }
      };

      if (this.cartAction === 'show_added_message' && this.addedText) {
        setTimeout(closeModal, 1500); // Allows the 'added' message to display before closing the modal
      } else {
        closeModal();
      }
    }
  }

  showLoadingState() {
    this.toggleElements(this.addToCartText, false);
    this.toggleElements(this.loadingIcon, true, 'hidden');
    this.toggleAddButton(true);
  }

  hideLoadingState() {
    this.toggleElements(this.loadingIcon, false, 'hidden');
    this.toggleCartActionDisplay();
  }

  toggleCartActionDisplay() {
    if (this.cartAction === 'show_added_message' && this.addedText) {
      // Show the added text message and update the cart count indicator
      this.addedText.style.display = 'block';
      setTimeout(() => {
        this.toggleAddToCartText(true);
        this.toggleAddButton(false);
        this.updateCartCountIndicator();
      }, 2000);
    } else if (this.cartType === 'drawer' && this.cartAction === 'go_to_or_open_cart') {
      // Open the cart drawer
      this.toggleAddToCartText(true);
      this.openCartDrawer();
      this.toggleAddButton(false);
      this.updateCartCountIndicator();
    } else {
      // Redirect to the cart page
      this.toggleAddToCartText(true);
      this.toggleAddButton(false);
      window.location = window.routes.cart_url;
    }
  }

  toggleAddToCartText(show) {
    // Show the added text message and hide the add to cart text
    if (this.addedText) this.addedText.style.display = show ? 'none' : 'block';
    // Show the add to cart text and hide the added text message
    if (this.addToCartText) this.addToCartText.style.display = show ? 'block' : 'none';
  }

  toggleElements(element, show, className) {
    if (!element) return;
    if (className) {
      show ? element.classList.remove(className) : element.classList.add(className);
    } else {
      element.style.display = show ? 'block' : 'none';
    }
  }

  toggleAddButton(disable = true) {
    const addButton = this.querySelector('[name="add"]');
    if (!addButton) return;

    addButton.disabled = disable;
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this.onSubmitBound);
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}

// --- GLOBAL CART CLEANUP ---
// Handles two cleanup tasks whenever the cart changes:
//   1. Remove orphaned bag deposit when no meal plans remain
//   2. Clear orphaned meal-plan discount code when no meal plans remain
//
// Notes:
// - Always fetches /cart.js for the true state. Add-flow events emit only the
//   just-added items, never trust that payload.
// - Listens to several event names because cart drawer remove handlers vary
//   across themes. A re-entry guard prevents loops.
// - Discount clearing tries multiple endpoints because Shopify's AJAX
//   discount-removal is inconsistent across stores.

let __rawkureCleanupInFlight = false;

async function __rawkureClearCartDiscount() {
  // Try several methods because no single AJAX endpoint reliably clears
  // Shopify's cart discount across all themes/stores.

  // 1. /cart/update.js with empty discount (undocumented but most reliable)
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    });
  } catch (e) { /* try next */ }

  // 2. Legacy /discount/clear endpoint
  try {
    await fetch('/discount/clear', {
      method: 'GET',
      credentials: 'same-origin'
    });
  } catch (e) { /* try next */ }

  // 3. Empty discount with redirect
  try {
    await fetch(`/discount/?redirect=${encodeURIComponent('/cart')}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    });
  } catch (e) { /* nothing else to try */ }
}

async function __rawkureCleanOrphans() {
  if (__rawkureCleanupInFlight) return;

  // Skip while any ProductForm is mid-submission (deposit may be in flight)
  const anyFormProcessing = Array.from(document.querySelectorAll('product-form'))
    .some(el => el.isProcessing);
  if (anyFormProcessing) return;

  __rawkureCleanupInFlight = true;
  try {
    let cart;
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      cart = await response.json();
    } catch (error) {
      console.warn('Cart cleanup: unable to fetch /cart.js', error);
      return;
    }

    if (!cart || !Array.isArray(cart.items)) return;

    const hasMealPlan = cart.items.some(item => {
      if (!item.properties) return false;
      if (Array.isArray(item.properties)) {
        return item.properties.some(p => p.name === '_rawkure_meal_plan' || p.name === 'Weeks');
      }
      return item.properties['_rawkure_meal_plan'] || item.properties['Weeks'];
    });

    const depositItems = cart.items.filter(item => {
      if (!item.properties) return false;
      if (Array.isArray(item.properties)) {
        return item.properties.some(p => p.name === '_rawkure_is_deposit' && String(p.value) === 'true');
      }
      return String(item.properties['_rawkure_is_deposit']) === 'true';
    });

    const currentDepositQty = depositItems.reduce((sum, item) => sum + item.quantity, 0);

    let didChange = false;

    // 1. Remove orphan deposit when no meal plans remain
    if (!hasMealPlan && currentDepositQty > 0) {
      const updates = {};
      depositItems.forEach(item => { updates[item.key] = 0; });
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        didChange = true;
      } catch (error) {
        console.error('Error removing orphaned deposit:', error);
      }
    }

    // 2. Recalculate the meal-plan discount based on what's actually in cart
    // Picks the highest-weeks meal plan remaining and applies that tier's code.
    // If no meal plans remain → clears the discount.
    const discountChanged = await __rawkureRecalculateMealPlanDiscount(cart);
    if (discountChanged) didChange = true;

    if (didChange) {
      window.eventBus?.emit('render:cart:drawer');
    }
  } finally {
    __rawkureCleanupInFlight = false;
  }
}

// Pulls the Weeks count from a line item, handling array and object property
// shapes Shopify can return.
function __rawkureGetItemWeeks(item) {
  if (!item || !item.properties) return 0;
  let weeksStr;
  if (Array.isArray(item.properties)) {
    const prop = item.properties.find(p => p.name === 'Weeks' || p.name === '_rawkure_meal_plan');
    weeksStr = prop && prop.value;
  } else {
    weeksStr = item.properties['Weeks'] || item.properties['_rawkure_meal_plan'];
  }
  const match = String(weeksStr || '').match(/\d+/);
  if (match) return parseInt(match[0], 10);
  // Fallback: line quantity (the form sets quantity = weeks on add)
  return item.quantity || 0;
}

// Looks up the discount code that corresponds to a given week count, using
// the same map structure ProductForm.resolveMealPlanDiscountCode supports.
function __rawkureLookupDiscountCode(map, weeks) {
  if (!map || !weeks) return '';
  const weeksKey = String(weeks);
  if (map.weeks && typeof map.weeks === 'object' && typeof map.weeks[weeksKey] === 'string' && map.weeks[weeksKey].trim()) {
    return map.weeks[weeksKey].trim();
  }
  if (typeof map[weeksKey] === 'string' && map[weeksKey].trim()) {
    return map[weeksKey].trim();
  }
  return '';
}

async function __rawkureRecalculateMealPlanDiscount(cart) {
  const discountMap = window.__rawkureMealPlanDiscountCodes;
  const currentCode = (Array.isArray(cart.discount_codes) && cart.discount_codes[0] && cart.discount_codes[0].code) || '';

  // Identify meal-plan line items (have Weeks property and are NOT the deposit)
  const mealPlanItems = cart.items.filter(item => {
    if (!item.properties) return false;
    const isDeposit = Array.isArray(item.properties)
      ? item.properties.some(p => p.name === '_rawkure_is_deposit' && String(p.value) === 'true')
      : String(item.properties['_rawkure_is_deposit']) === 'true';
    if (isDeposit) return false;
    const hasWeeks = Array.isArray(item.properties)
      ? item.properties.some(p => p.name === 'Weeks' || p.name === '_rawkure_meal_plan')
      : (item.properties['Weeks'] || item.properties['_rawkure_meal_plan']);
    return !!hasWeeks;
  });

  // No meal plans left → clear any active discount
  if (mealPlanItems.length === 0) {
    if (currentCode) {
      await __rawkureClearCartDiscount();
      return true;
    }
    return false;
  }

  // We can't compute the expected code without the discount map
  if (!discountMap) return false;

  // Pick the highest-weeks remaining plan and look up its code
  let highestWeeks = 0;
  mealPlanItems.forEach(item => {
    const w = __rawkureGetItemWeeks(item);
    if (w > highestWeeks) highestWeeks = w;
  });
  const expectedCode = __rawkureLookupDiscountCode(discountMap, highestWeeks);

  // Already correct → do nothing
  if (expectedCode === currentCode) return false;

  // Mismatch: clear and (re)apply
  await __rawkureClearCartDiscount();
  if (expectedCode) {
    try {
      await fetch(`/discount/${encodeURIComponent(expectedCode)}?redirect=${encodeURIComponent('/cart')}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
    } catch (error) {
      console.warn('Failed reapplying recalculated discount code', error);
    }
  }
  return true;
}

// Listen on multiple event names because cart-drawer remove handlers vary.
// The re-entry guard prevents the loop when our cleanup emits render:cart:drawer.
['update:cart:drawer', 'render:cart:drawer', 'cart:updated', 'cart:refresh', 'cart:change']
  .forEach(eventName => {
    window.eventBus?.on(eventName, __rawkureCleanOrphans);
  });

// PRIMARY TRIGGER: intercept fetch so we catch every cart mutation regardless
// of which event (if any) the theme emits. Many cart drawers call
// /cart/change.js directly and re-render without emitting on the eventBus.
// We schedule cleanup AFTER the response so the cart state is the new one.
(function installCartFetchInterceptor() {
  if (window.__rawkureFetchPatched) return;
  window.__rawkureFetchPatched = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async function(input, init) {
    const response = await originalFetch(input, init);

    try {
      // Skip if our own cleanup is doing this fetch (prevents loops)
      if (__rawkureCleanupInFlight) return response;

      const url = typeof input === 'string'
        ? input
        : (input && input.url) || '';

      // Cart mutation endpoints we care about
      const isCartMutation =
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear');

      if (isCartMutation) {
        // Defer so the theme's own handlers run first with the new cart
        setTimeout(() => { __rawkureCleanOrphans(); }, 50);
      }
    } catch (e) {
      // Never let cleanup logic break the original fetch flow
    }

    return response;
  };
})();

/******/ })()
;